export default function IndexPage() {
  if (typeof window !== 'undefined') {
    window.location.pathname = '/w/0'
  }

  return null
}
